// let objectList = [
//   {
//     "codigo" : "Codigo3",
//     "codigo_fornecedor" : "CodigoFornecedor3",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 13,
//     "estoque_minimo" : 0,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto3",
//     "preco" : 95,
//     "segmento" : [ "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo4",
//     "codigo_fornecedor" : "CodigoFornecedor4",
//     "compatibilidade" : [ "maquina2", "maquina3" ],
//     "estoque_atual" : 5,
//     "estoque_minimo" : 0,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto4",
//     "preco" : 75,
//     "segmento" : [ "aviamentos" ]
//   },
//   {
//     "Id" : "-MT37KeacYO5w-kgAuDl",
//     "codigo" : "Codigo5",
//     "codigo_fornecedor" : "CodigoFornecedor5",
//     "compatibilidade" : [ "maquina1", "maquina3" ],
//     "estoque_atual" : 4,
//     "estoque_minimo" : 5,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto5",
//     "preco" : 60,
//     "segmento" : [ "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo6",
//     "codigo_fornecedor" : "CodigoFornecedor6",
//     "compatibilidade" : [ "maquina2" ],
//     "estoque_atual" : 10,
//     "estoque_minimo" : 20,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto6",
//     "preco" : 55,
//     "segmento" : [ "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo7",
//     "codigo_fornecedor" : "CodigoFornecedor7",
//     "compatibilidade" : [ "maquina1" ],
//     "estoque_atual" : 17,
//     "estoque_minimo" : 20,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto7",
//     "preco" : 50,
//     "segmento" : [ "aviamentos" ]
//   },
//   {
//     "Id" : "-MT37KefHElx6UW_EQoH",
//     "codigo" : "Codigo8",
//     "codigo_fornecedor" : "CodigoFornecedor8",
//     "compatibilidade" : [ "maquina3" ],
//     "estoque_atual" : 20,
//     "estoque_minimo" : 30,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto8",
//     "preco" : 80,
//     "segmento" : [ "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo9",
//     "codigo_fornecedor" : "CodigoFornecedor9",
//     "compatibilidade" : [ "maquina2", "maquina3" ],
//     "estoque_atual" : 50,
//     "estoque_minimo" : 30,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto9",
//     "preco" : 100,
//     "segmento" : [ "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo10",
//     "codigo_fornecedor" : "CodigoFornecedor10",
//     "compatibilidade" : [ "maquina1", "maquina3" ],
//     "estoque_atual" : 50,
//     "estoque_minimo" : 30,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto10",
//     "preco" : 150,
//     "segmento" : [ "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo1",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2", "maquina3" ],
//     "estoque_atual" : 20,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto01",
//     "preco" : 110,
//     "segmento" : [ "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo12",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 20,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto12",
//     "preco" : 110,
//     "segmento" : [ "agulhas", "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo13",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto13",
//     "preco" : 110,
//     "segmento" : [ "agulhas", "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo14",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto14",
//     "preco" : 110,
//     "segmento" : [ "aviamentos", "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo14",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto14",
//     "preco" : 110,
//     "segmento" : [ "peças domésticas" ]
//   },
//   {
//     "codigo" : "Codigo15",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto15",
//     "preco" : 110,
//     "segmento" : [ "aviamentos", "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo16",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto16",
//     "preco" : 110,
//     "segmento" : [ "aviamentos", "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo17",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto17",
//     "preco" : 110,
//     "segmento" : [ "peças domésticas" ]
//   },
//   {
//     "codigo" : "Codigo18",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto18",
//     "preco" : 110,
//     "segmento" : [ "agulhas", "aviamentos" ]
//   },
//   {
//     "codigo" : "Codigo19",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina2" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 10,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto19",
//     "preco" : 110,
//     "segmento" : [ "aviamentos", "agulhas" ]
//   },
//   {
//     "codigo" : "Codigo20",
//     "codigo_fornecedor" : "CodigoFornecedor1",
//     "compatibilidade" : [ "maquina1", "maquina3" ],
//     "estoque_atual" : 25,
//     "estoque_minimo" : 15,
//     "imagem" : "https://moveislinhares.vteximg.com.br/arquivos/ids/157944-430-430/104607.png?v=637018071918930000",
//     "nome" : "Produto20",
//     "preco" : 110,
//     "segmento" : [ "aviamentos", "agulhas"  ]
//   }
// ];

export const onlyNumber = value => value.replace(/\D+/g, '');

const headingsMap = {
  codigo: 'Código',
  nome: 'Nome',
  preco: 'Preço',
  codigo_fornecedor: 'Código do Forncecedor',
  estoque_minimo: 'Estoque Mínimo',
  estoque_atual: 'Estoque Atual'
}

const copyToClipboard = (objectList) => {
  let textToCopy = getTextToCopyFromObjectList(objectList);

  let ghostInput = document.createElement("textarea");
  ghostInput.style.height = "0";
  ghostInput.style.overflow = "hidden";
  ghostInput.style.position = "fixed";
  ghostInput.value = textToCopy;
  document.body.appendChild(ghostInput);
  ghostInput.focus();
  ghostInput.select();
  document.execCommand('copy');

  document.body.removeChild(ghostInput);
};

const getTextToCopyFromObjectList = (objectList) => {
  const tab = '                ';
  let header = '';
  let keys = Object.keys(headingsMap);
  let maxes = {};

  fillingMaxesForTheHeader(keys, maxes);

  fillingMaxesForTheWholeList(objectList, keys, maxes);

  keys.forEach(key => {
    header += fillWithSpaces(headingsMap[key], maxes[key]) + tab;
  });

  let finalString = header + '\r\n';

  objectList.forEach(obj => {
    keys.forEach(key => {
      finalString += fillWithSpaces(obj[key], maxes[key]) + tab;
    });

    finalString += '\r\n';
  });

  return finalString;
};

const fillingMaxesForTheHeader = (keys, maxes) => {
  keys.forEach(key => {
    maxes[key] = headingsMap[key].length;
  });
}

const fillingMaxesForTheWholeList = (objectList, keys, maxes) => {
  objectList.forEach(obj => {
    keys.forEach(key => {
      obj[key] = obj[key].toString();
      maxes[key] = Math.max(maxes[key], obj[key].length);
    });
  });
}

const fillWithSpaces = (text, size) => {
  const diff = size - text.length;

  if (diff <= 0) {
    return text;
  }

  return text + (' ').repeat(diff);
}

export { copyToClipboard }